var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgYoutube = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 47,
    viewBox: "0 0 68 47",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8267 8.655C64.4802 7.34988 63.7746 6.15407 62.7811 5.18837C61.7876 4.22266 60.5414 3.52126 59.1683 3.155C54.1517 2 34.085 2 34.085 2C34.085 2 14.0183 2 9.00167 3.265C7.62864 3.63126 6.38243 4.33266 5.38893 5.29837C4.39542 6.26407 3.6898 7.45988 3.34333 8.765C2.42521 13.5653 1.97611 18.4349 2.00167 23.3125C1.96894 28.2269 2.41807 33.1336 3.34333 37.97C3.7253 39.2346 4.44673 40.3849 5.43792 41.3098C6.42911 42.2347 7.65656 42.903 9.00167 43.25C14.0183 44.515 34.085 44.515 34.085 44.515C34.085 44.515 54.1517 44.515 59.1683 43.25C60.5414 42.8837 61.7876 42.1823 62.7811 41.2166C63.7746 40.2509 64.4802 39.0551 64.8267 37.75C65.7377 32.9859 66.1868 28.1534 66.1683 23.3125C66.2011 18.3981 65.7519 13.4914 64.8267 8.655V8.655Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5225 32.3049L44.2933 23.3124L27.5225 14.3199V32.3049Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYoutube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/youtube.7e07af17.svg";
export { ForwardRef as ReactComponent };